import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify.js';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import {BadgePlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueMathjax from 'vue-mathjax'
import underscore from 'vue-underscore';
import jQuery from './plugins/jquery.js';
import router from './router.js';
import axios from 'axios';
import VueAxios from 'vue-axios';

// global components
import ProgressCircle from './components/ProgressCircle.vue';
import PageDrawer from './components/PageDrawer.vue';
import PageSection from './components/PageSection.vue';
import PageSubsection from './components/PageSubsection.vue';
import PageHeader from './components/PageHeader.vue';
import PageContent from './components/PageContent.vue';

Vue.component('progress-circle', ProgressCircle)
Vue.component('page-drawer', PageDrawer)
Vue.component('page-section', PageSection)
Vue.component('page-header', PageHeader)
Vue.component('page-content', PageContent)
Vue.component('page-subsection', PageSubsection)

import SidebarLayout from './layouts/SidebarLayout.vue';
import BasicLayout from './layouts/BasicLayout.vue';
Vue.component('sidebar-layout', SidebarLayout)
Vue.component('basic-layout', BasicLayout)
Vue.use(VueMathjax)
Vue.use(underscore);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(BadgePlugin)

// global variable
Vue.prototype.$API_URL = process.env.VUE_APP_API_URL;
Vue.prototype.$ENV = process.env.NODE_ENV;
Vue.prototype.$USER_KEY = '';
Vue.prototype.$PROJECT_RESOURCES = {};

new Vue({
    router: router,
    vuetify,
    BootstrapVue,
    BadgePlugin,
    jQuery,
    render: h => h(App),
}).$mount('#app')

// Vue.extend({
//   data: () => ({
//      active: true
//   }),
//   beforeRouteUpdate(to, from, next) {
//     if (this.active) {
//       next(false);
//     } else {
//       next();
//     }
// },
// })
